<script>
import GroupLimitsCrudListVue from '@/app/modules/contacard/limits/groupLimits/GroupLimitsCrudList.vue';
import StorageMixin from '@/app/arch/mixins/StorageMixin';

export default {
  name: 'UserGroupLimitList',
  extends: GroupLimitsCrudListVue,
  mixins: [StorageMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: '',
          nomRazaoSocial: '',
          nomCliente: '',
        };
      },
    },
  },
  data: (vm) => ({
    overrideHeaders: vm.setOverrideHeaders,
  }),
  computed: {
    clientId() {
      return this.value.id;
    },
    userId() {
      return this.$route.params.id;
    },
    customParams() {
      return {
        backRoute: 'users.edit',
        backParams: {
          id: this.userId,
        },
      };
    },
    payload() {
      return this.value;
    },
  },
  methods: {
    prepareRequest(params = {}) {
      return this.requestClass.list({
        idCliente: this.clientId,
        ...params,
      });
    },
    editAction(row) {
      this.saveLocalItem(
        'groupLimitsParams',
        this.customParams,
      );
      this.navigateTo(
        this.editRoute,
        {
          id: row.id,
        },
      );
    },
    prepareResponseData(data = []) {
      const { nomRazaoSocial, nomCliente } = this.payload;
      return data.map(
        (item) => ({
          ...item,
          nomRazaoSocial,
          nomCliente,
        }),
      );
    },
    setOverrideHeaders(header) {
      if (!header) return header;
      const { text, key } = header;
      if (this.isKey(key, 2)) {
        return {
          text,
          value: 'nomCliente',
        };
      }
      if (this.isKey(key, 3)) {
        return {
          text,
          value: 'nomRazaoSocial',
        };
      }
      return header;
    },
    isKey(key, i) {
      return `header_${i}` === key;
    },
  },
};
</script>
